import React, { useEffect, useRef, useState } from 'react'
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader'
import FormContainer from '../../../components/CommonComponents/FormContainer'
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper'
import Wrapper from '../../../components/CommonComponents/Wrapper'
import MessageLabel from '../../../components/CommonComponents/MessageLabel'
import MessageSubHeading from '../../../components/CommonComponents/MessageSubHeading'
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput'
import JoditEditor from 'jodit-react'
import Select from "react-select";
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect'
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch'
import AdminDownloadFile from '../../../components/CommonComponents/AdminDownloadFile'
import AdminMiniPlayer from '../../../components/CommonComponents/AdminMiniPlayer';
import AdminCustomURLCopy from '../../../components/CommonComponents/AdminCustomURLCopy';
import AdminProcessButton from '../../../components/CommonComponents/AdminProcessButton'
import AdminYoutubePlayer from '../../../components/CommonComponents/AdminYoutubePlayer'
import AdminImageUploadZone from '../../../components/CommonComponents/AdminImageUploadZone'
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton'
import AdminCustomRadio from '../../../components/CommonComponents/AdminCustomRadio'
import { TagsInput } from 'react-tag-input-component'
import { PiSubtitlesLight } from 'react-icons/pi'
import { useMyContext } from '../../../components/Provider/CommonProvider'
import useCompressImageConfig from '../../../components/CommonApis/Compressimageapi'
import usePpvGlobalImageConfig from '../../../components/CommonApis/ppv_global_change'
import { useLocation, useParams } from 'react-router-dom'
import { getItemToken } from '../../../Utils/localStorageUtils'
import AdminCustomArea from '../../../components/CommonComponents/AdminCustomArea'
import MessageHeading from '../../../components/CommonComponents/MessageHeading'
import MessageBox from '../../../components/CommonComponents/MessageBox'
import { toast } from 'react-toastify'
import axios from 'axios'
import { slugGenerator } from '../../../components/CommonMethod/CommonMethods'
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif'
import { IconMyDelete } from '../../../Assets/MyIcons'
import RightWrapper from '../../../components/CommonComponents/RightWrapper'
import { IoMdInformationCircle } from 'react-icons/io'
import AdminDeleteModal from '../../../components/CommonComponents/AdminDeleteModal'
import Response_Processing from '../../../layout/Others/Response_Processing'
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation'
import { IoClose } from 'react-icons/io5'
import { connect } from 'react-redux'
import AdminGalleryModal from '../../../components/CommonComponents/AdminGalleryModal'
import { navigateChecker } from '../../../components/navigateChecker'
import AdminAIModal from '../../../components/CommonComponents/AdminAImodal'
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from '../../../CustomFields/saveCustomFieldsStrict'
import PushNotificationSettings from '../../../components/CommonComponents/PushNotificationSettings';
import LanguageAddUpdate from "../../Language/Manage_Language/LanguageAddUpdate";
import ArtistAddUpdate from "../../Audio/Artist_Management/ArtistAddUpdate";
import SeriesGenreAddUpdate from "./SeriesGenreAddUpdate";
import AddManageAge from "../../Site/Settings/AddManageAge";
import ContentClassification from "../../Site/Settings/Site_Setting/ContentClassification";
import { MdAddCircle } from "react-icons/md";

// Recursive Checkbox Component for nested categories
const TreeCheckboxEpisode = ({ node, selectedIds, onToggle, depth = 0 }) => {
    const isChecked = (selectedIds || []).includes(Number(node.id));
    const hasChildren = Array.isArray(node.sub_category) && node.sub_category.length > 0;
    return (
        <div style={{ paddingLeft: depth * 18 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', padding: '4px 0' }}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => onToggle(Number(node.id))}
                    style={{ accentColor: 'var(--primary-color, #6366f1)', width: 15, height: 15 }}
                />
                <span className="theme-text-color" style={{ fontSize: 14 }}>{node.name}</span>
            </label>
            {hasChildren && node.sub_category.map(child => (
                <TreeCheckboxEpisode key={child.id} node={child} selectedIds={selectedIds} onToggle={onToggle} depth={depth + 1} />
            ))}
        </div>
    );
};

// Main Dropdown Component for Tree Selection
const CategoryMultiSelectEpisode = ({ options, selectedIds, onChange, error }) => {
    const [open, setOpen] = useState(false);
    const handleToggle = (id) => {
        const updated = (selectedIds || []).includes(id)
            ? selectedIds.filter(s => s !== id)
            : [...(selectedIds || []), id];
        onChange(updated);
    };
    const collectNames = (nodes) => (nodes || []).flatMap(n => [
        ...((selectedIds || []).includes(Number(n.id)) ? [n.name] : []),
        ...collectNames(n.sub_category || [])
    ]);
    const selectedNames = collectNames(options).join(', ') || 'Select categories';
    return (
        <div className="position-relative mb-3">
            <div
                id="episode-category-multiselect-toggle"
                onClick={() => setOpen(o => !o)}
                className="custom-input custom-input-border w-100 d-flex align-items-center justify-content-between"
                style={{ cursor: 'pointer', minHeight: 42, padding: '6px 12px' }}
            >
                <span style={{ color: (selectedIds || []).length ? 'inherit' : '#888', fontSize: 14 }}>{selectedNames}</span>
                <span style={{ fontSize: 11 }}>&#9660;</span>
            </div>
            {open && (
                <div
                    id="episode-category-multiselect-dropdown"
                    className="theme-bg-color"
                    style={{ position: 'absolute', zIndex: 999, top: '100%', left: 0, right: 0, maxHeight: 260, overflowY: 'auto', border: '1px solid rgba(128,128,128,0.3)', borderRadius: 6, padding: '8px 12px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
                >
                    {(options || []).length === 0 && <p className="theme-text-color opacity-50" style={{ fontSize: 13 }}>No categories found</p>}
                    {(options || []).map(node => (
                        <TreeCheckboxEpisode key={node.id} node={node} selectedIds={selectedIds} onToggle={handleToggle} />
                    ))}
                </div>
            )}
            {error && <div className="errorred mt-1" style={{ fontSize: 13 }}>{error}</div>}
        </div>
    );
};

const EpisodeAddUpate = ({ storageSetting, languageCodeData, siteTheme, onlyPermission }) => {
    const { fetchRequest, handleFileChangeProvider, buildDynamicSubText, validateOrientationBySlug, validateImageRatio, globalImageUplaodAPI, imageValidationAPI } = useMyContext()
    const { compressResolutionFormat } = useCompressImageConfig();
    const { allCurrencylistfromappi, globalPpvStatusActive } = usePpvGlobalImageConfig();

    const [imagerequiredValidation, setImagerequiredValidation] = useState(null)

    const baseURL = process.env.REACT_APP_Baseurl
    const headers = getItemToken('access_token')
    const editVideoRegex = /^\/edit-episode\/\d+$/
    const { id } = useParams()
    const location = useLocation()
    const { search } = location
    const queryParams = new URLSearchParams(search);
    const seriesId = queryParams.get('seriesid');
    const episodeId = queryParams.get('episodeid');
    const seasonId = queryParams.get('seasonid');

    const combinedRef = useRef({
        title: null,
        slug: null,
        episode_description: null,
        details: null,
        rating: null,
        age_restrict: null,
        duration: null,
        free_duration_time: null,
        skip_start_time: null,
        skip_end_time: null,
        recap_start_time: null,
        mid_advertisement_sequence_time: null,
        recap_end_time: null,
        notification_image: null,
        content_classification: null,
    });

    const labelSource = 'add-episode'
    const editApi = `${baseURL}/admin/series/episode/edit`
    const updateApi = `${baseURL}/admin/series/episode/update`
    const createApi = `${baseURL}/admin/series/episode/create`
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
    const seoApi = `${baseURL}/admin/series/episode/seo/update`
    const imageApi = globalImageUplaodAPI()
    const imageValidationApi = imageValidationAPI()
    const globalImageDeleteApi = `${baseURL}/admin/global-image-delete`
    const subtitleUploadApi = `${baseURL}/admin/series/episode/subtitle/upload`
    const updatePPV = `${baseURL}/admin/series/episode/payperviewprice/update`
    const trailerApiLibrary = `${baseURL}/admin/library/upload?upload_type=trailer&clone_to=episode&action_type=updated`
    const assingAPI = `${baseURL}/admin/series/episode/assign`
    const generateAISuggestionApi = `${baseURL}/admin/ai-prompt-response`
    const [modalTarget, setModalTarget] = useState(null);
    const [defaultPrompt, setDefaultPrompt] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState({
        state: "formData",
        title: "",
        slug: "",
        brightcove_video_id: "",
        brightcove_trailer_id: "",
        url_type: '',
        selected_categories: [],
        tv_image: "",
        image: "",
        player_image: "",
        age_restrict: 0,
        rating: 0,
        publish_type: "",
        free_duration_status: 0,
        free_duration_time: "",
        enable_Tips: 0,
        enable_restream: 0,
        global_ppv: 0,
        global_ios_ppv: 0,
        // Ideabiz purchase plan mapping for episode
        ideabiz_purchase_plans_id: null,
        google_product_id_ppvs_id: null,
        trailer_type: 'mp4_video_upload',
        error: "",
        pre_ads: "",
        post_ads: "",
        mid_ads_category: "",
        upload_single: null,
        active: 0,
        mid_advertisement_sequence_time: "",
        push_notification_enabled: 0,
        push_notification_title: "",
        push_notification_description: "",
        push_notification_image: "",
        push_notification_image_url: "",
        push_notification_publish_type: "publish_now",
        push_notification_publish_time: "",
        source_type: 4,
        source_type_name: "Episodes",
        slug: "",
        content_classification: "",
        ssai_vmap_url: "",
        is_ads: 0,
        banner: 0,
        slider_image: "",
        Slider_Thumbnail: "",
    })
    const [editData, setEditData] = useState({
        state: "editData"
    })
    const [getGeofencingAvailableCountries, setGetGeoFencingAvailableCountries] = useState(null);
    const [getGeofencing, setGetGeoFencing] = useState(null);
    const [seasonmatchuserdata, setSeasonmatchuserdata] = useState();
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
        artistsOption: [],
        categoryOption: [],
        languageOption: [],
        blockCountryOption: [],
        availableCountryOption: [],
        relatedVideos: [],
        relatedPlaylists: [],
        writerOption: [],
        musicianOption: [],
        ageOption: [],
        albumOption: [],
        accessOption: [],
        iosOption: [],
        lyricsOption: [],
        globalOption: [],
        contentClassificationOption: [],
    })

    const [subtitleFile, setSubtitleFile] = useState()
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [modelClose, setModelClose] = useState(false);
    const [pricemodel, setPriceModel] = useState('');
    const [itemToDelete, setItemToDelete] = useState({});
    const [languageModal, setLanguageModal] = useState(false);
    const [artistModal, setArtistModal] = useState(false);
    const [categoryModal, setCategoryModal] = useState(false);
    const [ageModal, setAgeModal] = useState(false);
    const [contentClassificationModal, setContentClassificationModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [formDataError, setFormDataError] = useState({})
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [playerImageFile, setPlayerImageFile] = useState(null);
    const [titleImageFile, setTitleImageFile] = useState(null);
    const [tvImageFile, setTvImageFile] = useState(null);
    const [notificationImageFile, setNotificationImageFile] = useState(null);
    const [sliderImageFile, setSliderImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [currentType, setCurrentType] = useState("")
    const [preadsarray, setPreadsarray] = useState([])
    const [postadsarray, setPostadsarray] = useState([])
    const [midadsarray, setMidadsarray] = useState([])
    const [seriesSlug, setSeriesSlug] = useState([]);
    const [convertPrice, setConvertPrice] = useState({
        source_type: 4,
        source_id: "",
        PPVType: 0,
        PriceType: "",
        ActualPrice: "",
        IOSPrice: "",
        convertedPriceRates: []
    })
    const [galleryModal, setGalleryModal] = useState(false)
    const [selectedIds, setSelectedIds] = useState([]);
    const [customFieldValues, setCustomFieldValues] = useState({});

    const currentYear = new Date().getFullYear();
    formData.year = currentYear;
    const years = Array.from({ length: currentYear - 1895 + 1 }, (_, index) => ({ name: 1895 + index, value: 1895 + index }));

    const handleLibraryChange = async (e, name) => {
        const files = e.target.files;
        setFormData((prev) => ({
            ...prev,
            [name]: files ? files[0] : null
        }));
        if (!files?.length) return;
        const allowedTypes = /video\/(mp4|x-matroska|webm|quicktime|avi)/;
        for (let file of files) {
            if (!allowedTypes.test(file.type)) {
                toast.error(`Unsupported file format: ${file.name}`);
                e.target.value = ''; // Clear the file input
                return;
            }
        }

        const { site_storage_limit, site_storage_memory } = storageSetting;

        // Convert storage limit to bytes
        const memoryUnits = {
            MB: 1024 ** 2,
            GB: 1024 ** 3,
            TB: 1024 ** 4
        };

        const unitMultiplier = memoryUnits[site_storage_memory];
        if (!unitMultiplier) {
            alert(`Invalid storage unit: ${site_storage_memory}`);
            return;
        }

        const byteLimit = site_storage_limit * unitMultiplier;

        // Calculate total file size
        const totalSize = Array.from(files).reduce((sum, file) => sum + file.size, 0);

        if (totalSize > byteLimit) {
            alert(`Upload exceeds limit: ${site_storage_limit} ${site_storage_memory}`);
            e.target.value = null; // Reset file input
            return;
        }
        if (name == "trailer") {
            await handleFileChangeProvider(e, `${trailerApiLibrary}&video_id=${episodeId}&series_id=${formData?.series_id}&season_id=${formData?.season_id}`, "trailer");
        }

    }

    const handleToggleGalleryModel = (val) => {
        setGalleryModal(prev => !prev)
        if (val == "clear") {
            setSelectedIds([])
        }
    }

    const handleCheckboxChange = (id) => {
        if (id) {
            setSelectedIds((prevSelectedIds) => {
                if (prevSelectedIds?.includes(id)) {
                    return [];
                } else {
                    return [id];
                }
            });
        }
    };

    const handleMoveVideo = async (selectIds) => {
        try {
            let response, result = null
            response = await axios.post(`${assingAPI}?video_id=${episodeId}&library_id=${selectIds?.[0]}&updated_type=${episodeId ? 'trailer' : 'video'}`, {}, { headers: headers });
            result = response?.data;
            if (result?.status) {
                toast.success(result?.message)
                setSelectedIds([])
                setGalleryModal(false)
                setFormData(prevState => ({
                    ...prevState,
                    trailer_type: ""
                }));
            }
            else {
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
    }


    const handlePriceModal = () => {
        setPriceModel((prev) => !prev)
    }
    const handlePriceModalClose = async (status) => {
        const actualStatus = typeof status === 'string' ? status : null;
        if (actualStatus != "done") {
            setFormData((prev) => ({
                ...prev,
                ppv_price: editData?.ppv_price,
                ios_ppv_price: editData?.ios_ppv_price,
                global_ppv: editData?.global_ppv,
                individualPPVTrigger: actualStatus
            }))
        }
        setFormData((prev) => ({
            ...prev,
            individualPPVTrigger: actualStatus
        }))
        await setPriceModel(false)
    }

    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        if (value == 'title_image') {
            setTitleImageFile(null)
        }
        if (value == 'tv_image') {
            setTvImageFile(null)
        }
        if (value == 'player_image') {
            setPlayerImageFile(null)
        }
        if (value == 'notification_image') {
            setNotificationImageFile(null)
        }
        if (value == 'slider_image') {
            setSliderImageFile(null)
        }
        setFormDataError((prev) => ({
            ...prev,
            [value]: ""
        }))
        setFormData((prev) => ({
            ...prev,
            [value]: "",
            ...(value == 'slider_image' ? { Slider_Thumbnail: "" } : {})
        }))
        setSubtitleFile((prev) => ({
            ...prev,
            [value]: ""
        }))

    }


    const handleFileChange = async (event) => {
        const { files, name, value, accept, dataset } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));
        setFormData((prev) => ({
            ...prev,
            [name]: ""
        }))
        let newFile = files[0];
        let fileContent, isValidSizeVertical, isValidSizeHorizontal
        if (files?.length > 0) {
            // Check if this is a subtitle file upload
            const isSubtitleUpload = accept && accept.includes('text/vtt') || accept.includes('text/srt');

            if (isSubtitleUpload) {
                // Handle subtitle file validation
                const fileName = files[0]?.name?.toLowerCase();
                const isValidSubtitle = fileName?.endsWith('.vtt') || fileName?.endsWith('.srt');

                if (!isValidSubtitle) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Only VTT and SRT subtitle files are allowed.",
                    }));
                    return;
                }

                // Additional validation for subtitle file content
                const reader = new FileReader();
                reader.onload = (e) => {
                    const content = e.target.result;
                    let isValidContent = false;

                    if (fileName?.endsWith('.vtt')) {
                        // Basic VTT validation - should start with WEBVTT
                        isValidContent = content.startsWith('WEBVTT');
                        if (!isValidContent) {
                            setFormDataError((prev) => ({
                                ...prev,
                                [name]: "Invalid VTT file format. File must start with 'WEBVTT'.",
                            }));
                            return;
                        }
                    } else if (fileName?.endsWith('.srt')) {
                        // Basic SRT validation - should contain timestamp pattern
                        const srtPattern = /\d{2}:\d{2}:\d{2},\d{3} --> \d{2}:\d{2}:\d{2},\d{3}/;
                        isValidContent = srtPattern.test(content);
                        if (!isValidContent) {
                            setFormDataError((prev) => ({
                                ...prev,
                                [name]: "Invalid SRT file format. File must contain proper timestamp format.",
                            }));
                            return;
                        }
                    }

                    // If validation passes, set the subtitle file
                    setSubtitleFile((prev) => ({
                        ...prev,
                        [name]: newFile,
                    }));
                    setFormData((prev) => ({
                        ...prev,
                        [name]: newFile
                    }));
                };
                reader.readAsText(files[0]);
                return; // Exit early for subtitle files
            } else {
                // Handle image file validation
                const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
                if (!allowedTypes.includes(files[0]?.type)) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Only JPG, JPEG, WEBP and PNG files are allowed.",
                    }));
                    return;
                }
                const reader = new FileReader();
                const readFile = (file) => {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = (error) => reject(error);
                        reader.readAsDataURL(file);
                    });
                };
                fileContent = await readFile(newFile);
                // Dynamic orientation validation if provided
                if (dataset?.orientation && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                    const result = await validateOrientationBySlug(newFile, dataset.orientation);
                    if (!result.ok) {
                        let msg = 'Selected image does not match the required orientation.';
                        if (result?.expected) {
                            const ratio = `${result.expected.width}:${result.expected.height}`;
                            msg = `Image must be in ${result?.ratio || ratio} Ratio or ${result.expected.width}x${result.expected.height}px`;
                        }
                        setFormDataError((prev) => ({ ...prev, [name]: msg }));
                        if (name === 'image') setCoverImageFile(null);
                        if (name === 'player_image') setPlayerImageFile(null);
                        if (name === 'tv_image') setTvImageFile(null);
                        combinedRef.current[name]?.focus?.();
                        return;
                    }
                }
                isValidSizeVertical = await validateImageRatio(newFile, 2 / 3, 1080, 1620);
                isValidSizeHorizontal = await validateImageRatio(newFile, 16 / 9, 1280, 720);

                // Process image files
                const checkSize = compressResolutionFormat?.episode === 1;

                if (name == 'image') {
                    setCoverImageFile(newFile);
                    setFormData((prev) => ({
                        ...prev,
                        [name]: newFile
                    }))
                    if (!dataset?.orientation && !isValidSizeVertical && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 2:3 Ratio or 1080x1620px.",
                        }));
                    }
                }
                if (name == 'player_image') {
                    setPlayerImageFile(newFile);
                    setFormData((prev) => ({
                        ...prev,
                        [name]: newFile
                    }))
                    if (!dataset?.orientation && !isValidSizeHorizontal && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                        }));
                    }
                }
                if (name == 'tv_image') {
                    setTvImageFile(newFile);
                    setFormData((prev) => ({
                        ...prev,
                        [name]: newFile
                    }))
                    if (!dataset?.orientation && !isValidSizeHorizontal && checkSize && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Image must be in 16:9 Ratio or 1280x720px.",
                        }));
                    }
                }
                if (name == 'notification_image') {
                    setNotificationImageFile(newFile);
                    setFormData((prev) => ({
                        ...prev,
                        [name]: newFile
                    }))
                }
                if (name === 'slider_image') {
                    const isValidRatio = await validateImageRatio(newFile, 8 / 3, 3840, 1440);
                    if (!isValidRatio && compressResolutionFormat?.disable_image_ratio_validation !== 1) {
                        setFormDataError((prev) => ({
                            ...prev,
                            [name]: "Slider image must be in 8:3 Ratio or 3840x1440px.",
                        }));
                    }
                    setSliderImageFile(newFile);
                    setFormData((prev) => ({
                        ...prev,
                        [name]: newFile
                    }))
                }
            } // End of image processing block
        }
    };

    const multiSelectLabel = (array, valueKey, labelKey) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey]
        })) : [];
    };

    const assignDefault = (value, defaultValue = 0) => value ? value : defaultValue;

    const fetchData = async () => {
        setLoading(true)
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${editApi}/${episodeId}`,
                params: {},
                data: {},
            })
            const result = response;
            setSeasonmatchuserdata(result);
            setGetGeoFencing(result?.getGeofencing);
            setGetGeoFencingAvailableCountries(result?.getGeofencingAvailableCountries);
            setPreadsarray(result?.pre_advertisement);
            setPostadsarray(result?.post_advertisement);
            setMidadsarray(result?.ads_category);
            setSeriesSlug(result?.Series?.slug)
            const previousFormData = result?.episode;
            const updatedFormData = {
                ...previousFormData,
                selected_artists: multiSelectLabel(previousFormData?.selected_artists, 'id', 'artist_name'),
                selected_categories: Array.isArray(previousFormData?.selected_categories)
                    ? previousFormData?.selected_categories.map(cat => Number(cat.id))
                    : [],
                selected_Languages: multiSelectLabel(previousFormData?.selected_Languages, 'id', 'name'),
                selected_blocked_country: multiSelectLabel(previousFormData?.selected_blocked_country, 'id', 'name'),
                selected_available_country: multiSelectLabel(previousFormData?.selected_available_country, 'id', 'country_name'),
                ideabiz_purchase_plans_id: previousFormData?.ideabiz_purchase_plans_id || null,
                google_product_id_ppvs_id: previousFormData?.google_product_id_ppvs_id || null,
                search_tags: previousFormData?.search_tags?.split(",")?.map((tag) => tag.trim()),
                ppv_status: assignDefault(previousFormData.ppv_status),
                album_id: assignDefault(previousFormData.album_id),
                rating: assignDefault(previousFormData.rating),
                active: previousFormData?.status == 0 ? 1 : assignDefault(previousFormData?.active),
                draft: assignDefault(previousFormData.draft),
                featured: assignDefault(previousFormData.featured),
                banner: assignDefault(previousFormData.banner),
                views: assignDefault(previousFormData.views),
                year: previousFormData.year,
                publish_type: previousFormData.publish_type ? previousFormData.publish_type : 'publish_now',
                age_restrict: assignDefault(previousFormData.age_restrict),
                url_type: previousFormData?.type == "transcoding_video" ? "mp4_video_upload" : previousFormData?.type,
                brightcove_video_id: previousFormData?.brightcove_video_id,
                brightcove_trailer_id: previousFormData?.brightcove_trailer_id,
                push_notification_enabled: assignDefault(previousFormData?.push_notification_enabled),
                push_notification_title: previousFormData?.push_notification_title || "",
                push_notification_description: previousFormData?.push_notification_description || "",
                push_notification_image: previousFormData?.push_notification_image || "",
                push_notification_image_url: previousFormData?.push_notification_image_url || "",
                push_notification_publish_type: previousFormData?.push_notification_publish_type || "publish_now",
                push_notification_publish_time: previousFormData?.push_notification_publish_time ? previousFormData.push_notification_publish_time.replace(' ', 'T').slice(0, 16) : "",
                ssai_vmap_url: previousFormData?.ssai_vmap_url || "",
                source_type: 4,
                source_type_name: "Episodes",
                slug: previousFormData?.slug || "",
                Slider_Thumbnail: previousFormData?.slider_image_URL || "",
            };
            setCurrentType(previousFormData?.type == "transcoding_video" ? "mp4_video_upload" : previousFormData?.type)
            setFormData((prev) => ({ ...prev, ...updatedFormData }))
            setEditData((prev) => ({ ...prev, updatedFormData }))


            // Default DropDown List

            const defaultoptionslist = {
                artistsOption: multiSelectLabel(result.Series_artist, 'id', 'artist_name'),
                categoryOption: result.series_categories || [],
                languageOption: multiSelectLabel(result.Series_language, 'id', 'name'),
                blockCountryOption: multiSelectLabel(result.block_country, 'id', 'name'),
                availableCountryOption: multiSelectLabel(result.available_country, 'id', 'name'),
                ageOption: result.Age_Restrict,
                accessOption: result.user_access,
                iosOption: result?.InappPurchase,
                videoSubtitle: result.episode_subtitle,
                globalOption: result.ppv_gobal_price ? result.ppv_gobal_price : '',
                defaultCurrency: result?.DefaultCurrency,
                trailerOption: result?.trailerType,
                // Ideabiz PPV purchase plans for episode
                ideabizPPVPurchase: result?.ideabizPPVPurchase || [],
                googleProductIdPPV: result?.googleProductIdPPV || [],
                contentClassificationOption: multiSelectLabel(result?.AllClassification, 'title', 'title'),
            }

            if (!defaultoptionslist.googleProductIdPPV || defaultoptionslist.googleProductIdPPV.length === 0) {
                try {
                    const createResponse = await axios.get(`${createApi}`, { headers: headers });
                    if (createResponse?.data?.googleProductIdPPV?.length) {
                        defaultoptionslist.googleProductIdPPV = createResponse.data.googleProductIdPPV;
                    }
                } catch (error) {
                    console.error("Error fetching fallback googleProductIdPPV:", error);
                }
            }
            setConvertPrice(prevState => {
                return {
                    ...prevState,
                    source_id: episodeId,
                    PPVType: 0,
                    PriceType: result?.DefaultCurrency?.code,
                    ActualPrice: formData?.ppv_price,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: [...result?.ContentPriceRates]
                };
            });
            setDefaultOption((prev) => ({ ...prev, ...defaultoptionslist }));

            if (updatedFormData.content_classification) {
                const selectedTitles = updatedFormData.content_classification.split(',').map(item => item.trim());
                const selected = defaultoptionslist.contentClassificationOption.filter(opt => selectedTitles.includes(opt.value));
                setFormData(prev => ({ ...prev, selected_content_classification: selected }));
            }
        } catch (error) {
            if (error?.response?.status == 404 || error?.response?.status == 500) {
                setFormData((prev) => ({ ...prev, error: error.response.data.message || "ID not found or api something went wrong." }))
            }
        }
        finally {
            setLoading(false)
        }
    };

    const handleFileDelete = async () => {
        setShowOverlay(true);
        try {
            const response = await axios.delete(globalImageDeleteApi, {
                headers: headers,
                data: {
                    modelName: 'Episode',
                    id: parseInt(episodeId),
                    deleteType: 'subtitles',
                    subtitleLanguage: itemToDelete?.short_code
                }
            });

            const result = response?.data;
            if (result?.status) {
                setShowOverlay(false);
                setItemToDelete({})
                setWithOutRefresh(!withOutRefresh);
                toast.success(result?.message);
                closeModal()
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
                closeModal()
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    }

    const focusInput = (inputName) => {
        if (combinedRef.current[inputName]) {
            combinedRef.current[inputName].focus();
        }
    };

    const labelFetch = async () => {
        try {
            setShowOverlay(true)
            const response = await fetchRequest({
                method: 'GET',
                url: `${labelApi}`,
                params: {},
                data: {}
            })
            const result = response?.label_management
            setLabelDisplay(result)
        }
        catch (err) {
            toast.error(err?.response?.data?.message)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const getDefaultCurrencySetting = () => {
        const dc = defaultOption?.defaultCurrency;
        if (Array.isArray(dc)) return dc?.[0] || {};
        return dc || {};
    }

    const handleCovertPrice = async (value) => {
        let formIsValid = true
        if (!formData?.ppv_price) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                ppv_price: "ppv price cannot be empty.",
            }));
            combinedRef.current['ppv_price'].focus()
            formIsValid = false;
        }
        if (formIsValid) {
            const selectedCountryCode = defaultOption?.defaultCurrency?.code
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${selectedCountryCode}`);
                const rates = response.data.rates;
                let convertedPrices = allCurrencylistfromappi?.map(item => {
                    let country_name = item?.country;
                    let Symbol = item?.Symbol || item?.symbol;
                    let Code = item?.code;

                    const matchingCountry = allCurrencylistfromappi.find(currency => currency.code === item?.code);
                    if (matchingCountry) {
                        country_name = matchingCountry?.country;
                        Symbol = matchingCountry?.Symbol || matchingCountry?.symbol;
                    }

                    return {
                        Code: Code,
                        Country: country_name,
                        Symbol: Symbol,
                        ConvertedPriceRate: (value * (rates[item?.code] || 0)).toFixed(2),
                        price: value,
                        RateDifference: ((value * (rates[item?.code] || 0)) - value).toFixed(2),
                        editPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        ChangedPrice: (value * (rates[item?.code] || 0)).toFixed(2),
                        isEditable: true,
                    };
                });

                const cfg = getDefaultCurrencySetting();
                if (cfg?.same_country_toggle == 1 && cfg?.same_currency_country) {
                    const targetCountryName = cfg?.same_currency_country;
                    convertedPrices = convertedPrices.filter(item => 
                        String(item.Code).toUpperCase() === String(cfg?.code).toUpperCase() || 
                        String(item?.Country).toLowerCase() === String(targetCountryName).toLowerCase()
                    );
                } else if (cfg?.enable_secondary_currency == 1 && cfg?.enable_multi_currency != 1) {
                    const rawSec = cfg?.secondary_currencies;
                    const secCur = (rawSec ? (typeof rawSec === 'string' ? JSON.parse(rawSec) : rawSec) : []) || [];
                    const secondaryCodes = secCur.map(c => String(typeof c === 'object' ? (c.short_code || c.value || c.code) : c).toUpperCase());
                    convertedPrices = convertedPrices.filter(item => item?.Code && secondaryCodes.includes(String(item.Code).toUpperCase()));
                }

                setConvertPrice(prevState => ({
                    ...prevState,
                    source_id: episodeId,
                    PPVType: 0,
                    PriceType: selectedCountryCode,
                    ActualPrice: value,
                    IOSPrice: formData?.ios_ppv_price,
                    convertedPriceRates: convertedPrices
                }));
            } catch (error) {
                console.error('Error fetching currency conversion rates:', error);
            }
        }
    };

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;

        if (name == "skip_start_time" || name == "mid_advertisement_sequence_time" || name == "skip_end_time" || name == "skip_start_session" || name == "recap_start_session" || name == "recap_start_time" || name == "recap_end_time" || name == "url_linktym" || name == "urlEnd_linksec" || name == "free_duration_time" || name == "duration") {
            const formattedInput = value.replace(/\D/g, "");

            const formattedTime = formattedInput
                .replace(/^(\d{2})(\d{2})(\d{2})$/, "$1:$2:$3")
                .substr(0, 8);

            setFormData((prev) => ({
                ...prev,
                [name]: formattedTime,
            }));

            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
            return
        }

        if (type === "radio") {
            if (["publish_now", "publish_later"].includes(name)) {
                setFormData(prev => ({
                    ...prev,
                    publish_type: checked ? name : ''
                }));
            }
        }

        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
            if (name == "free_duration_status") {
                if (!checked) {
                    setFormDataError((prev) => ({
                        ...prev,
                        ['free_duration_time']: '',
                    }));
                }
            }
        }

        if (type === 'text' || type == "time" || type == "date") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
            if (name == "title") {
                setFormDataError((prev) => ({
                    ...prev,
                    ['slug']: '',
                }));
            }
        }

        if (type === "number") {
            setFormData((prev) => ({
                ...prev,
                [name]: value.replace(/[^0-9.]/g, '')
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === "datetime-local") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        if (type === "textarea") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

    };

    const handlePriceChangeInput = (e, index) => {
        const { value } = e.target;
        setConvertPrice(prevState => {
            const updatedRates = [...prevState.convertedPriceRates];
            updatedRates[index] = {
                ...updatedRates[index],
                ConvertedPriceRate: value
            };
            return {
                ...prevState,
                convertedPriceRates: updatedRates
            };
        });
    };

    const handleTagsChange = (newTags) => {
        const cleanedTags = (newTags || [])
            .flatMap((tag) => String(tag ?? "").split(","))
            .map((tag) => tag.trim().toLowerCase())
            .filter((tag) => tag !== "")
            .filter((value, index, self) => self.indexOf(value) === index);
        setFormData((prevFormData) => ({
            ...prevFormData,
            search_tags: cleanedTags,
        }));
    };

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setFormData((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOptions
        }))
        setFormDataError((prev) => ({
            ...prev,
            [actionMeta.name]: ""
        }))
    }

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            if (name === 'episode-image') {
                const imageFields = [];

                if (coverImageFile) {
                    formDataAdd.append('image', coverImageFile);
                    imageFields.push('image');
                }
                if (playerImageFile) {
                    formDataAdd.append('player_image', playerImageFile);
                    imageFields.push('player_image');
                }
                if (tvImageFile) {
                    formDataAdd.append('tv_image', tvImageFile);
                    imageFields.push('tv_image');
                }
                if (notificationImageFile) {
                    formDataAdd.append('push_notification_image', notificationImageFile);
                    imageFields.push('push_notification_image');
                }
                if (sliderImageFile) {
                    formDataAdd.append('slider_image', sliderImageFile);
                    imageFields.push('slider_image');
                }

                formDataAdd.append('id', id);
                formDataAdd.append('modelName', 'Episode');

                imageFields.forEach((field) => {
                    formDataAdd.append('imageFields[]', field);
                });

                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
                if (response?.status) {
                    toast.success(response?.message)
                }
            }

            if (name == "subtitle") {
                // Check if there are any subtitle files to upload
                const hasSubtitleFiles = Object.keys(subtitleFile || {}).some(key => subtitleFile[key]);

                if (hasSubtitleFiles) {
                    const modelName = "Episode";
                    const subtitleFields = [];
                    const subtitleFilesToUpload = {};

                    // Prepare subtitle files for upload
                    Object.keys(subtitleFile).forEach(short_code => {
                        if (subtitleFile[short_code]) {
                            const videoData = defaultOption?.videoSubtitle.find(video => video.short_code === short_code);
                            if (videoData) {
                                // Use the short_code directly as the field name for backend processing
                                const fieldName = short_code;
                                formDataAdd.append(fieldName, subtitleFile[short_code]);
                                subtitleFields.push(fieldName);
                                subtitleFilesToUpload[fieldName] = {
                                    language: videoData.language,
                                    short_code: videoData.short_code
                                };
                            }
                        }
                    });

                    if (subtitleFields.length > 0) {
                        formDataAdd.append('modelName', modelName);
                        formDataAdd.append('id', episodeId);
                        subtitleFields.forEach(field => {
                            formDataAdd.append('subtitleFields[]', field);
                        });

                        try {

                            const response = await fetchRequest({
                                method: 'POST',
                                url: imageApi,
                                data: formDataAdd,
                            });

                            if (response?.status) {
                                toast.success(response?.message || "Subtitles uploaded successfully!");
                                // Clear uploaded subtitle files
                                Object.keys(subtitleFilesToUpload).forEach(fieldName => {
                                    const short_code = subtitleFilesToUpload[fieldName].short_code;
                                    setSubtitleFile((prev) => ({
                                        ...prev,
                                        [short_code]: ""
                                    }));
                                });
                            } else {
                                console.error("Failed to upload subtitles:", response?.message);
                                toast.error(response?.message || "Failed to upload subtitles");
                            }
                        } catch (error) {
                            console.error('Error uploading subtitles:', error);
                            toast.error(error?.response?.data?.message || "Error uploading subtitles");
                        }
                    }
                }
            }
            setCoverImageFile(null)
            setPlayerImageFile(null)
            setTvImageFile(null)
            setTitleImageFile(null)
            setSliderImageFile(null)
            setNotificationImageFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleSeoUpload = async (id) => {
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["Meta_description", "website_page_title", "website_URL"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            formDataAdd['episode_id'] = id
            const response = await fetchRequest({
                method: 'POST',
                url: `${seoApi}`,
                params: {},
                data: formDataAdd
            })
            if (!response?.status) {
                toast.error(response?.data?.message)
            }
        } catch (err) {
            console.error(err)
        }
    }

    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.title);
        }
    };

    const generateSlug = (title) => {
        const slug = slugGenerator(title)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };

    const handleInputKeyDowntitle = (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            if (!formData?.slug) {
                generateSlug(formData?.name);
            }
        }
    };


    const handleBlurTitleEdit = () => {
        generateSlug(formData?.slug);
    };


    const closeModal = () => {
        setModelClose(!closeModal);
        setShowModal(false);
    };

    const handleSubtitleDelete = (item) => {
        setModelClose(!modelClose);
        setItemToDelete(item)
    }


    useEffect(async () => {
        const ImageValidationresponse = await fetchRequest({
            method: 'GET',
            url: imageValidationApi,
            params: {},
            data: {},
        })
        setImagerequiredValidation(ImageValidationresponse?.Compress_image)
    }, [])


    const formValidation = async () => {
        let formIsValid = true;
        let errors = {};

        if (formData.trailer_type) {
            switch (formData?.trailer_type) {
                case "mp4_url":
                    if (!formData?.trailer_url || formData?.trailer_url?.trim() === "") {
                        // errors.trailer_url = "Please enter a valid trailer URL";
                        setFormDataError((prevFormData) => ({
                            ...prevFormData,
                            trailer_url: "URL must end with .mp4 extension",
                        }));
                        formIsValid = false;
                    } else if (!formData?.trailer_url?.toLowerCase()?.endsWith('.mp4')) {
                        // errors.trailer_url = "URL must end with .mp4 extension";
                        setFormDataError((prevFormData) => ({
                            ...prevFormData,
                            trailer_url: "URL must end with .mp4 extension",
                        }));
                        formIsValid = false;
                    }
                    break;

                case "m3u8_url":
                    if (!formData?.trailer_url || formData?.trailer_url?.trim() === "") {
                        // errors.trailer_url = "Please enter a valid trailer URL";
                        setFormDataError((prevFormData) => ({
                            ...prevFormData,
                            trailer_url: "Please enter a valid trailer URL",
                        }));
                        formIsValid = false;
                    } else if (!formData?.trailer_url?.toLowerCase()?.endsWith('.m3u8')) {
                        // errors.trailer_url = "URL must end with .m3u8 extension";
                        setFormDataError((prevFormData) => ({
                            ...prevFormData,
                            trailer_url: "URL must end with .m3u8 extension",
                        }));
                        formIsValid = false;
                    }
                    break;

                case "embed_url":
                    if (!formData?.trailer_url || formData?.trailer_url?.trim() === "") {
                        // errors.trailer_url = "Please enter a embed url";
                        setFormDataError((prevFormData) => ({
                            ...prevFormData,
                            trailer_url: "Please enter a embed url",
                        }));
                        formIsValid = false;
                    } else if (formData.trailer_url) {
                        const embedCode = formData?.trailer_url?.trim();
                        const youtubeEmbedRegex = /^https?:\/\/(?:www\.)?youtube\.com\/embed\/[a-zA-Z0-9_-]+(?:\?[a-zA-Z0-9_=&-]+)?$/;

                        if (!youtubeEmbedRegex.test(embedCode)) {
                            // errors.trailer_url = "Please enter a valid YouTube embed URL (e.g., https://www.youtube.com/embed/VIDEO_ID)";
                            setFormDataError((prevFormData) => ({
                                ...prevFormData,
                                trailer_url: "Please enter a valid YouTube embed URL (e.g., https://www.youtube.com/embed/xxx)",
                            }));
                            formIsValid = false;
                        }
                    }
                    break;

                case "mp4_video_upload":
                    if (!formData.trailer_url || !formData?.trailer_source_url) {
                        // errors.trailer_url = "Please upload a trailer video file";
                        setFormDataError((prevFormData) => ({
                            ...prevFormData,
                            trailer_url: "Please upload a trailer video file",
                        }));
                        toast.error("Please upload a trailer video file");
                        formIsValid = false;
                    }
                    break;

                case "transcoding_video":
                    // Add any rules here if needed
                    break;

                default:
                    break;
            }
        }

        setFormDataError((prev) => ({
            ...prev,
            ...errors,
        }));

        const validateTimeField = ({ field, label, requiredIf, focusField }) => {
            const value = formData?.[field];
            const rawDuration = value?.replace(/\D/g, '') || '';

            if (requiredIf && (!value || rawDuration?.length !== 6)) {
                setFormDataError(prev => ({
                    ...prev,
                    [field]: `${label} must be exactly 6 digits in HH:MM:SS format.`,
                }));
                combinedRef.current?.[focusField]?.focus();
                formIsValid = false;
                return;
            }

            const hours = parseInt(rawDuration.slice(0, 2), 10);
            const minutes = parseInt(rawDuration.slice(2, 4), 10);
            const seconds = parseInt(rawDuration.slice(4, 6), 10);

            const isValidTime = (
                hours >= 0 && hours <= 23 &&
                minutes >= 0 && minutes <= 59 &&
                seconds >= 0 && seconds <= 59
            );

            if ((!isValidTime || (hours === 0 && minutes === 0 && seconds === 0)) && field != "skip_start_time" && field != "skip_start_session" && field != "recap_start_time" && field != "url_linktym") {
                setFormDataError(prev => ({
                    ...prev,
                    [field]: `${label} must be a valid time (not 00:00:00).`,
                }));
                combinedRef.current?.[focusField]?.focus();
                formIsValid = false;
            }
        };

        if (!formData?.title || formData.title.trim() === '') {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                title: "Title cannot be empty or contain only spaces.",
            }));
            combinedRef.current?.['title']?.focus();
            formIsValid = false;
        }
        if (!formData?.slug || formData.slug.trim() === '') {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Slug cannot be empty or contain only spaces.",
            }));
            combinedRef.current?.['slug']?.focus();
            formIsValid = false;
        }
        if (Array.isArray(formData.selected_categories) && formData.selected_categories.length === 0) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                selected_categories: "Category cannot be empty.",
            }));
            combinedRef.current?.['selected_categories']?.focus();
            formIsValid = false;
        } else if (!formData.selected_categories) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                selected_categories: "Category cannot be empty.",
            }));
            formIsValid = false;
        }
        if (!formData?.age_restrict) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                age_restrict: "Age cannot be empty.",
            }));
            combinedRef.current?.['age_restrict']?.focus();
            formIsValid = false;
        }
        if (!formData?.access) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                access: "Choose the access.",
            }));
            combinedRef.current?.['access']?.focus();
            formIsValid = false;
        }
        if (!formData?.duration) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                duration: "Duration cannot be empty.",
            }));
            combinedRef.current?.['duration']?.focus();
            formIsValid = false;
        }
        if (formData?.duration) {
            validateTimeField({
                field: 'duration',
                label: 'Duration',
                requiredIf: true,
                focusField: 'duration',
            });
        }

        if (formData?.free_duration_status) {
            if (!formData?.free_duration_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    free_duration_time: "Free Duration cannot be empty.",
                }));
                combinedRef.current?.['free_duration_time']?.focus();
                formIsValid = false;
            } else {
                validateTimeField({
                    field: 'free_duration_time',
                    label: 'Free Duration Time',
                    requiredIf: true,
                    focusField: 'free_duration_time',
                });
            }
        }

        if (formData?.skip_start_time) {
            validateTimeField({
                field: 'skip_start_time',
                label: 'Skip Start Time',
                requiredIf: true,
                focusField: 'skip_start_time',
            });
        }

        if (formData?.skip_end_time) {
            if (!formData?.skip_start_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    title: "Start Time should not be empty",
                }));
                combinedRef.current?.['title']?.focus();
                formIsValid = false;
            }
            validateTimeField({
                field: 'skip_end_time',
                label: 'Skip End Time',
                requiredIf: true,
                focusField: 'skip_end_time',
            });
        }

        if (formData?.recap_start_time) {
            validateTimeField({
                field: 'recap_start_time',
                label: 'Recap Start Time',
                requiredIf: true,
                focusField: 'recap_start_time',
            });
        }

        if (formData?.recap_end_time) {
            validateTimeField({
                field: 'recap_end_time',
                label: 'Recap End Session',
                requiredIf: true,
                focusField: 'recap_end_time',
            });
        }

        if (formData?.skip_start_session) {
            validateTimeField({
                field: 'skip_start_session',
                label: 'Skip Start Session',
                requiredIf: true,
                focusField: 'skip_start_session',
            });
        }

        if (formData?.recap_start_session) {
            validateTimeField({
                field: 'recap_start_session',
                label: 'Recap Start Session',
                requiredIf: true,
                focusField: 'recap_start_session',
            });
        }

        if (formData?.mid_advertisement_sequence_time) {
            validateTimeField({
                field: 'mid_advertisement_sequence_time',
                label: 'Mid Advertisement Sequence Time',
                requiredIf: true,
                focusField: 'mid_advertisement_sequence_time',
            });
        }

        if (formData?.url_linktym) {
            validateTimeField({
                field: 'url_linktym',
                label: 'URL Link Time',
                requiredIf: true,
                focusField: 'url_linktym',
            });
        }

        if (formData?.urlEnd_linksec) {
            validateTimeField({
                field: "urlEnd_linksec",
                label: "URL End Link",
                requiredIf: true,
                focusField: "urlEnd_linksec",
            });
        }

        if (formDataError?.image) {
            combinedRef.current?.['image']?.focus();
            formIsValid = false;
        }
        if (formDataError?.player_image) {
            combinedRef.current?.['player_image']?.focus();
            formIsValid = false;
        }
        if (formDataError?.tv_image) {
            combinedRef.current?.['tv_image']?.focus();
            formIsValid = false;
        }
        if (formData?.free_duration_status == 1) {
            if (!formData?.free_duration_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    free_duration_time: "Free Duration Time can't be empty",
                }));
                combinedRef.current?.['free_duration_time']?.focus();
                formIsValid = false;
            } else {
                validateTimeField({
                    field: 'free_duration_time',
                    label: 'Free Duration Time',
                    requiredIf: true,
                    focusField: 'free_duration_time',
                });
            }
        }
        if (Array.isArray(formData?.selected_categories) && formData?.selected_categories?.length == 0) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                selected_categories: "Category cannot be empty.",
            }));
            combinedRef.current?.['selected_categories']?.focus();
            formIsValid = false;
        }
        const parentSeriesIsPPV = seasonmatchuserdata?.Series?.access === 'ppv' || seasonmatchuserdata?.Series?.access === 'PPV' || seasonmatchuserdata?.Series?.user_access === 'ppv' || seasonmatchuserdata?.Series?.user_access === 'PPV';
        if (formData?.access == "ppv" && !parentSeriesIsPPV) {
            if (globalPpvStatusActive?.PPV_Individual_Contents == 1 && !formData?.ppv_price && !formData?.ios_ppv_price) {
                setPriceModel(true)
            }
            if (!formData?.ppv_price) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    ppv_price: "PPV price cannot be empty.",
                }));
                combinedRef.current?.['ppv_price']?.focus();
                formIsValid = false;
            }
            if (!formData?.ios_ppv_price) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    ios_ppv_price: "IOS price cannot be empty.",
                }));
                combinedRef.current?.['ios_ppv_price']?.focus();
                formIsValid = false;
            }
        }
        if (formData?.mid_ads_category) {
            if (!formData?.mid_advertisement_sequence_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    mid_advertisement_sequence_time: "Sequence tile cannot be empty.",
                }));
                combinedRef.current?.['mid_advertisement_sequence_time']?.focus();
                formIsValid = false;
            }
        }
        if (formData?.website_URL || formData?.url_link) {
            const urlPattern = /^https?:\/\/(?:[-\w.])+(?::[0-9]+)?(?:\/[^?\s]*)?(?:\?[^#\s]*)?(?:#[^\s]*)?$/i;
            if (formData?.website_URL && !urlPattern.test(formData.website_URL)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    website_URL: "Please enter a valid URL format starting with http:// or https://",
                }));
                combinedRef.current?.['website_URL']?.focus();
                formIsValid = false;
            }
            if (formData?.url_link && !urlPattern.test(formData.url_link)) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    url_link: "Please enter a valid URL format starting with http:// or https://",
                }));
                combinedRef.current?.['url_link']?.focus();
                formIsValid = false;
            }
        }
        if (formData?.publish_type == "publish_now") {
            if (!formData?.year) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    year: "Year cannot be empty.",
                }));
                combinedRef.current?.['year']?.focus();
                formIsValid = false;
            }
        }
        if (formData?.publish_type == "publish_later") {
            if (!formData?.publish_time) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    publish_time: "Publish time cannot be empty.",
                }));
                combinedRef.current?.['publish_time']?.focus();
                formIsValid = false;
            }
        }


        if (imagerequiredValidation?.episode === 1) {
            if (((episodeId && (formData?.image_url?.includes('default_vertical_image.webp') || formData?.image_url?.includes('uploads/settings/'))) || (!episodeId && !coverImageFile)) && !coverImageFile) {
                setFormDataError(prev => ({
                    ...prev,
                    image: "Please upload a cover image."
                }));
                combinedRef.current?.['image']?.focus();
                formIsValid = false;
            }
            if (((episodeId && (formData?.player_image_url?.includes('default_horizontal_image.webp') || formData?.player_image_url?.includes('uploads/settings/'))) || (!episodeId && !playerImageFile)) && !playerImageFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    "player_image": "Please upload a player image."

                }))
                combinedRef.current?.['player_image']?.focus();
                formIsValid = false;
            }
            if (((episodeId && (formData?.tv_image_url?.includes('default_horizontal_image.webp') || formData?.tv_image_url?.includes('uploads/settings/'))) || (!episodeId && !tvImageFile)) && !tvImageFile) {
                setFormDataError((prev) => ({
                    ...prev,
                    "tv_image": "Please upload a tv image."
                }))
                combinedRef.current?.['tv_image']?.focus();
                formIsValid = false;
            }
        }

        if (!formData?.title || formData?.title.trim().length < 3 || formData?.title.trim().length > 100) {
            toast.error("Title must be between 3 and 100 characters.");
            formIsValid = false;
        }

        if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            formIsValid = false;
        }

        if (formData?.banner === 1) {
            if (!sliderImageFile && (!formData?.Slider_Thumbnail || formData?.Slider_Thumbnail === "" || formData?.Slider_Thumbnail?.includes('default_vertical_image.webp') || formData?.Slider_Thumbnail?.includes('uploads/settings/'))) {
                setFormDataError((prev) => ({
                    ...prev,
                    slider_image: "Please upload a slider image.",
                }));
                combinedRef.current['slider_image']?.focus();
                formIsValid = false;
            }
        }
        return formIsValid;
    }

    const handlePPVPriceStore = async () => {
        setShowOverlay(true);
        try {
            // Send PPV conversion data along with the current Ideabiz plan ID (raw ID)
            const payload = {
                ...convertPrice,
                ideabiz_purchase_plans_id: formData?.ideabiz_purchase_plans_id || null,
                google_product_id_ppvs_id: formData?.google_product_id_ppvs_id || null,
                push_notification_enabled: formData?.push_notification_enabled || 0,
                push_notification_title: formData?.push_notification_title,
                push_notification_description: formData?.push_notification_description,
                push_notification_publish_type: formData?.push_notification_publish_type || 'publish_now',
                push_notification_publish_time: formData?.push_notification_publish_time,
                source_type: 4,
                source_type_name: "Episodes",
                slug: formData?.slug,
            };

            const response = await axios.post(`${updatePPV}`, payload, { headers: headers });
            const result = response?.data
            if (result?.status) {
                setShowOverlay(false);
                setPriceModel(false)
                toast.success(result?.message)
            }
            else {
                setShowOverlay(false);
                toast.error(result?.message)
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }
    }



    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if ([
                    "title", "slug", "year", "duration", "details", "episode_description", "age_restrict", "rating",
                    "recap_start_time", "recap_end_time", "recap_start_session", "skip_start_session", "skip_end_time", "skip_start_time",
                    "url_link", "urlEnd_linksec", "url_linktym", "active", "banner", "featured", "slider_image", "enable_video_title_image",
                    "free_duration_status", "free_duration_time", "mid_advertisement_sequence_time", "publish_type", "publish_time",
                    "access", "ppv_price", "global_ppv", "ios_ppv_price",
                    // include ideabiz purchase ID in episode update payload
                    "ideabiz_purchase_plans_id",
                    "google_product_id_ppvs_id",
                    "brightcove_video_id",
                    "brightcove_trailer_id",
                    "url_type", "type", "content_classification",
                    "trailer_embed_code", "trailer_m3u8_url", "trailer_mp4_url", "trailer_type", "series_id", "season_id", "trailer_type", "trailer_url",
                    "push_notification_enabled", "push_notification_title", "push_notification_description", "push_notification_publish_type", "push_notification_publish_time",
                    "source_type", "source_type_name", "slug", "is_ads"
                ].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }

            // Remove File objects to prevent serialization errors in JSON payload
            const imageFields = ['image', 'player_image', 'tv_image', 'slider_image'];
            imageFields.forEach(field => {
                if (formDataAdd[field] instanceof File) {
                    delete formDataAdd[field];
                }
            });

            formDataAdd['pre_ads'] = formData?.pre_ads
            formDataAdd['post_ads'] = formData?.post_ads
            formDataAdd['mid_ads_category'] = formData?.mid_ads_category
            formDataAdd['artist_id'] = formData?.selected_artists?.map((option) => option?.value)
            formDataAdd['block_country_id'] = formData?.selected_blocked_country?.map((option) => option?.value)
            formDataAdd['available_countries_id'] = formData?.selected_available_country?.map((option) => option?.value)
            formDataAdd['category_id'] = Array.isArray(formData?.selected_categories) ? formData.selected_categories : []
            formDataAdd['languages_id'] = formData?.selected_Languages?.map((option) => option?.value)
            formDataAdd['content_classification'] = formData?.selected_content_classification?.map((option) => option?.value).join(',')
            formDataAdd['search_tags'] = Array.isArray(formData?.search_tags) ? formData?.search_tags.join(',') : '';
            formDataAdd['status'] = formData?.publish_type == "publish_now" ? 1 : 0;
            formDataAdd['publish_status'] = formData?.publish_type == "publish_now" ? 1 : 0;

            const response = await fetchRequest({
                method: 'POST',
                url: `${updateApi}/${episodeId}`,
                params: {},
                data: formDataAdd
            })
            const result = response;
            if (result?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'episode', entityId: episodeId, values: customFieldValues });
                } catch (e) {
                    toast.error(e.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || playerImageFile || tvImageFile || titleImageFile || notificationImageFile || sliderImageFile) {
                    await handleFileUpload(result?.id, 'episode-image')
                }
                await handleFileUpload(result?.id, 'subtitle')
                await handleSeoUpload(result.id)
                if (formData?.individualPPVTrigger == "done") {
                    await handlePPVPriceStore()
                }
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)

            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const handleStore = async (e) => {
        e.preventDefault()
        if (await formValidation()) {
            handleUpdate()
        }
        else {
            console.table("validation")
        }
    }

    useEffect(() => {
        labelFetch()
        setFormDataError({})
    }, [])

    useEffect(async () => {
        if (episodeId) {
            await fetchData();
        } else {
            // For new episodes, we need to fetch the category list (tree)
            try {
                const response = await fetchRequest({
                    method: 'GET',
                    url: createApi,
                    params: {},
                    data: {},
                });
                if (seriesId) {
                    try {
                        const seriesResp = await axios.get(`${baseURL}/admin/series/edit/${seriesId}`, { headers: headers });
                        if (seriesResp?.data?.data) {
                            setSeasonmatchuserdata(prev => ({ ...prev, Series: seriesResp.data.data }));
                        }
                    } catch (e) {
                        console.error('Error fetching series data:', e);
                    }
                }
                if (response?.series_categories) {
                    setDefaultOption(prev => ({
                        ...prev,
                        categoryOption: response.series_categories,
                        languageOption: multiSelectLabel(response.Series_language, 'id', 'name'),
                        artistsOption: multiSelectLabel(response.Series_artist, 'id', 'artist_name'),
                        ageOption: response.Age_Restrict,
                        accessOption: response.user_access,
                        iosOption: response?.InappPurchase,
                        contentClassificationOption: multiSelectLabel(response?.AllClassification, 'title', 'title'),
                        ideabizPPVPurchase: response?.ideabizPPVPurchase || [],
                        googleProductIdPPV: response?.googleProductIdPPV || [],
                    }));
                }
            } catch (error) {
                console.error("Error fetching create data:", error);
            }
        }
    }, [withOutRefresh]);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            libraryMoveButton: ""
        }))
    }, [currentType])


    // Find index of current access level from formData
    const accessOptions = defaultOption?.accessOption || [];

    const currentAccessIndex = accessOptions.findIndex(
        (item) => item.role === seasonmatchuserdata?.SeriesSeason?.access
    );

    const filteredAccessOptions =
        currentAccessIndex >= 0
            ? accessOptions.filter((_item, index) => index >= currentAccessIndex)
            : accessOptions.filter((item) => item.role === formData?.access);

    useEffect(() => {
        if (languageModal || artistModal || categoryModal || pricemodel || galleryModal || ageModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => { document.body.style.overflow = 'auto'; };
    }, [languageModal, artistModal, categoryModal, pricemodel, galleryModal, ageModal]);

    if (loading) {
        return <Defaultloadinggif className={`heightOnLoader`} />
    }

    const confirmToggle = (suggestedText) => {
        if (suggestedText && typeof suggestedText === 'string' && modalTarget) {
            setFormData(prev => ({ ...prev, [modalTarget]: suggestedText }));
        }
        setShowModal(false);
        setModalTarget(null);
    };

    const handleModal = (target) => {
        setModalTarget(target);
        if (target === "episode_description") {
            setDefaultPrompt(`Give a short description about "${formData?.title || ""}"`);
        } else if (target === "details") {
            setDefaultPrompt(`Expand the content details for "${formData?.title || ""}"`);
        }
        setShowModal(true);
    };

    const generateSuggestion = async (promptText, setSuggestion, setLoading) => {
        const trimmedPrompt = promptText?.trim();
        setLoading(true);
        try {
            const response = await axios.post(
                generateAISuggestionApi,
                { prompt: trimmedPrompt },
                { headers }
            );
            if (response.data?.status) {
                setLoading(false);
                setSuggestion(response.data.response);
            } else {
                alert(response.data.message || "Failed to generate suggestion.");
            }
        } catch (error) {
            if (error.response?.status === 401) {
                alert("Token expired or invalid. Please login again.");
            } else {
                console.error(error);
                alert("Error generating suggestion.");
            }
        }
    };


    return (
        <div>
            {galleryModal && <AdminGalleryModal modelClose={galleryModal} closeAction={handleToggleGalleryModel} sourceType={16} saveAction={handleMoveVideo} changeAction={handleCheckboxChange} selectedIds={selectedIds} buttonText={("Select Trailer")} />}
            {showOverlay && (<Response_Processing />)}
            {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleFileDelete} buttonText={'custom'} message={`Are you sure you want to delete this video ${itemToDelete?.language} subtitle?`} />}

            {languageModal && (
                <div class={`modal packageModel fade ${languageModal && 'd-block show'}`} id="episodeLanguageModal" tabIndex="-1" role="dialog" aria-labelledby="episodeLanguageModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Language" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setLanguageModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <LanguageAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                                    if (newId && newName) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            languageOption: [...(prev?.languageOption || []), { value: newId, label: newName }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_Languages) ? prev.selected_Languages : [];
                                            return { ...prev, selected_Languages: [...curr, { value: newId, label: newName }] };
                                        });
                                    }
                                    setLanguageModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {artistModal && (
                <div class={`modal packageModel fade ${artistModal && 'd-block show'}`} id="episodeArtistModal" tabIndex="-1" role="dialog" aria-labelledby="episodeArtistModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Artist" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setArtistModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <ArtistAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                                    if (newId && newName) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            artistsOption: [...(prev?.artistsOption || []), { value: newId, label: newName }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_artists) ? prev.selected_artists : [];
                                            return { ...prev, selected_artists: [...curr, { value: newId, label: newName }] };
                                        });
                                    }
                                    setArtistModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {categoryModal && (
                <div class={`modal packageModel fade ${categoryModal && 'd-block show'}`} id="episodeCategoryModal" tabIndex="-1" role="dialog" aria-labelledby="episodeCategoryModalLabel" >
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Series Category" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setCategoryModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <SeriesGenreAddUpdate isModal={true} forceCreate={true} onSuccess={(newId, newName) => {
                                    if (newId && newName) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            categoryOption: [...(prev?.categoryOption || []), { value: newId, label: newName }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_categories) ? prev.selected_categories : [];
                                            return { ...prev, selected_categories: [...curr, newId] };
                                        });
                                    }
                                    setCategoryModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {ageModal && (
                <div class={`modal packageModel fade ${ageModal && 'd-block show'}`} id="episodeAgeModal" tabIndex="-1" role="dialog" aria-labelledby="episodeAgeModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Age" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setAgeModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <AddManageAge isModal={true} onSuccess={(newAge) => {
                                    if (newAge) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            ageOption: [...(prev?.ageOption || []), { age: newAge }]
                                        }));
                                        setFormData(prev => ({ ...prev, age_restrict: newAge }));
                                    }
                                    setAgeModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {contentClassificationModal && (
                <div class={`modal packageModel fade ${contentClassificationModal && 'd-block show'}`} id="episodeContentClassificationModal" tabIndex="-1" role="dialog" aria-labelledby="episodeContentClassificationModalLabel" >
                    <div className="modal-dialog modal-large" role="document">
                        <div className="modal-content theme-bg-color ">
                            <div className="modal-header theme-border-bottom-secondary">
                                <MessageBox text="Add Content Classification" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                                <button type="button" className='bg-transparent theme-text-color' onClick={() => setContentClassificationModal(false)} aria-label="Close"><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                            </div>
                            <div className="modal-body">
                                <ContentClassification isModal={true} onSuccess={(newTitle) => {
                                    if (newTitle) {
                                        setDefaultOption(prev => ({
                                            ...prev,
                                            contentClassificationOption: [...(prev?.contentClassificationOption || []), { value: newTitle, label: newTitle }]
                                        }));
                                        setFormData(prev => {
                                            const curr = Array.isArray(prev?.selected_content_classification) ? prev.selected_content_classification : [];
                                            return { ...prev, selected_content_classification: [...curr, { value: newTitle, label: newTitle }] };
                                        });
                                    }
                                    setContentClassificationModal(false);
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div class={`modal  packageModel fade ${pricemodel && 'd-block show'}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" >
                <div className="modal-dialog modal-large" role="document">
                    <div className="modal-content theme-bg-color ">
                        <div className="modal-header theme-border-bottom-secondary">
                            <MessageBox text="Price exchange" classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button id="ppvCloseModelUp" type="button" className='bg-transparent theme-text-color' onClick={handlePriceModalClose} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body">
                            <div className="row mx-0 align-items-start mb-3 ">
                                <div className="col-12 col-md-5 ps-0 ">
                                    <MessageLabel text={`${formData?.global_ppv == 0 ? labelDisplay?.[47]?.title : labelDisplay?.[47]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                    <AdminCustomInput isReadonly={formData?.global_ppv == 1} type="number" id="countryPPVPrice" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please enter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                </div>
                                <div className="col-12 col-md-5 ">
                                    <MessageLabel text={`${labelDisplay?.[48]?.title}  (${defaultOption?.defaultCurrency?.symbol} ${defaultOption?.defaultCurrency?.code}) - ${defaultOption?.defaultCurrency?.country}`} />
                                    <AdminCustomSelect id="countryPPVIOSPrice" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                </div>
                                {/* Ideabiz Purchase Plan - only when data is present */}
                                {Array.isArray(defaultOption?.ideabizPPVPurchase) && defaultOption.ideabizPPVPurchase.length > 0 && (
                                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                                        <MessageLabel text="Idea Biz Purchase" />
                                        <AdminCustomSelect
                                            id="episode-ideabiz-purchase-plans"
                                            name="ideabiz_purchase_plans_id"
                                            // Now storing only the raw ID for ideabiz_purchase_plans_id
                                            value={formData?.ideabiz_purchase_plans_id || ''}
                                            onChange={(e) => {
                                                const planId = e.target.value;
                                                setFormData(prev => ({
                                                    ...prev,
                                                    ideabiz_purchase_plans_id: planId ? parseInt(planId) : null,
                                                }));
                                            }}
                                            options={defaultOption.ideabizPPVPurchase.map(plan => ({
                                                name: plan?.plan_name || plan?.name || `Plan ${plan?.id}`,
                                                value: plan?.id,
                                            }))}
                                            defaultOptionName="Choose Idea Biz plan"
                                        />
                                    </div>
                                )}
                                {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                                    <div className="col-12 col-md-5 mt-3 ps-0 ">
                                        <MessageLabel text="Google Purchase" />
                                        <AdminCustomSelect
                                            id="episode-google-product-ppvs"
                                            name="google_product_id_ppvs_id"
                                            value={formData?.google_product_id_ppvs_id || ''}
                                            onChange={(e) => {
                                                const planId = e.target.value;
                                                setFormData(prev => ({
                                                    ...prev,
                                                    google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                                                }));
                                            }}
                                            options={defaultOption.googleProductIdPPV.map(plan => ({
                                                name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                                                value: plan?.id,
                                            }))}
                                            defaultOptionName="Choose Google Purchase"
                                        />
                                    </div>
                                )}
                                <div className="col-12 col-md-2 pe-0 align-self-center mt-4">
                                    <AdminCustomButton id="covertPriceButton" className='px-3 py-1 m-0' saveMethod={() => handleCovertPrice(formData?.ppv_price)} saveText='Convert' />
                                </div>
                            </div>
                            <div className="priceTable rounded-3  ">
                                <table class="table rounded-3  position-relative">
                                    <thead className="theme-bg-color-secondary  z-index-1">
                                        <tr>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Country</th>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Current Price</th>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Converted Price</th>
                                            <th scope="col" className="theme-bg-color-secondary border-0 py-sm-3">Difference</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {convertPrice?.convertedPriceRates?.length ? convertPrice?.convertedPriceRates.map((item, index) => (
                                            <tr key={index}>
                                                <td className="" scope="row">{`${item?.Country} (${item?.Code})`}</td>
                                                <td className="">{item.Symbol} {item?.price || item?.ActualPrice}</td>
                                                <td className=""> <AdminCustomInput id="priceChangeInput" type="number" name="price" value={item?.ConvertedPriceRate} onChange={(e) => handlePriceChangeInput(e, index)} placeHolder={"Fill the custom price"} noMargin noBorder={formData?.global_ppv == 1} className={`${formData?.global_ppv == 1 && 'border-0'}`} /> </td>
                                                <td className="">{item?.RateDifference}</td>
                                            </tr>
                                        )) :
                                            <tr>
                                                <td colSpan={4} className="errorred text-center">* Please update the pricing according to the specific market in each currency !.</td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer  border-0">
                            <button id="ppvCloseModelDown" type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={handlePriceModalClose} ><MessageBox text="Cancel" /> </button>
                            <AdminCustomButton id="countryPriceSubmitButton" className='px-3 py-1 m-0 ' saveMethod={() => handlePriceModalClose("done")} saveText='Done' />
                        </div>
                    </div>
                </div>
            </div>
            <React.Fragment>
                <AdminBackNavigation path={`/manage-episode?seriesid=${formData?.series_id}&seasonid=${formData?.season_id}`} text='Back' />
                <AdminSaveHeader heading={labelDisplay?.[0]?.title} saveText={labelDisplay?.[44]?.title} saveMethod={handleStore} id={"episode-preview-button"} link={episodeId ? navigateChecker(languageCodeData, siteTheme, `series/${seriesSlug}/${formData.slug}/${episodeId}`) : ""} loading={showOverlay} />
                <FormContainer className="pb-5">
                    <LeftWrapper>
                        <Wrapper>

                            <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                            <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
                            <AdminCustomInput id="episode-title" type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

                            <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
                            <MessageSubHeading text={labelDisplay?.[4]?.sub_title} />
                            <AdminCustomInput id="episode-slug" type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onBlur={handleBlurTitleEdit} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />

                            {showModal && (<AdminAIModal modalDescription="Suggest AI" modalHeading="Generate Content" modelClose={showModal} sliderClose={closeModal} applySuggestion={confirmToggle} generateSuggestion={generateSuggestion} defaultPrompt={defaultPrompt} />)}
                            <MessageLabel text={labelDisplay?.[5]?.title} enableAI handleAIModal={() => handleModal("episode_description")} />
                            <MessageSubHeading text={labelDisplay?.[5]?.sub_title} />
                            <AdminCustomArea id="episode-description" name="episode_description" value={formData?.episode_description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.episode_description = el)} placeHolder={"episode description"} rows={5} maxLength={"250"} />

                            <MessageLabel text={labelDisplay?.[6]?.title} enableAI handleAIModal={() => handleModal("details")} />
                            <MessageSubHeading text={labelDisplay?.[6]?.sub_title} />
                            <JoditEditor className="episode-details mb-3" ref={(el) => (combinedRef.current.details = el)} value={formData?.details} onChange={(newContent) => setFormData(prev => ({ ...prev, details: newContent }))} />

                            <div className="card p-3 mt-3">
                                <MessageHeading text="Additional Fields" />
                                {/* Custom fields */}
                                <FieldRenderer2
                                    pageIdentifier={"episodes.edit"}
                                    entityType="episode"
                                    entityId={episodeId}
                                    text="Additional Fields"
                                />
                                <FieldRenderer
                                    pageIdentifier={"episodes.edit"}
                                    entityType="episode"
                                    entityId={episodeId}
                                    onChange={setCustomFieldValues}
                                />
                            </div>

                        </Wrapper>

                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[9]?.title} />

                            <div className="d-flex justify-content-between align-items-start">
                                <div className="pe-2">
                                    <MessageLabel text={labelDisplay?.[13]?.title} className="mandatorySimple" />
                                    <MessageSubHeading text={labelDisplay?.[13]?.sub_title} />
                                </div>
                                <button type="button" id="episode-category-add-button" className="vjs-big-play-button rounded" onClick={() => setCategoryModal(true)} title="Add Category">
                                    < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                </button>
                            </div>
                            <CategoryMultiSelectEpisode
                                options={defaultOption?.categoryOption || []}
                                selectedIds={formData?.selected_categories || []}
                                onChange={(ids) => {
                                    setFormData(prev => ({ ...prev, selected_categories: ids }));
                                    setFormDataError(prev => ({ ...prev, selected_categories: '' }));
                                }}
                                error={formDataError?.selected_categories}
                            />

                            <div className="d-flex justify-content-between align-items-start">
                                <div className="pe-2">
                                    <MessageLabel text={labelDisplay?.[11]?.title} className="mandatorySimple" />
                                    <MessageSubHeading text={labelDisplay?.[11]?.sub_title} />
                                </div>
                                <button type="button" id="episode-age-add-button" className="vjs-big-play-button rounded" onClick={() => setAgeModal(true)} title="Add Age">
                                    < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                </button>
                            </div>
                            <AdminCustomSelect id="episode-age-restrict" name="age_restrict" value={formData?.age_restrict} onChange={handleInput} ref={(el) => (combinedRef.current.age_restrict = el)} options={defaultOption?.ageOption?.map((item) => ({ name: item?.age, value: item?.age }))} error={formDataError?.age_restrict} defaultOptionName={"Choose an age"} />

                            <div className="d-flex justify-content-between align-items-start">
                                <div className="pe-2">
                                    <MessageLabel text={"Content Classification"} />
                                    <MessageSubHeading text={"Select the content classification"} />
                                </div>
                                <button type="button" id="episode-content-classification-add-button" className="vjs-big-play-button rounded" onClick={() => setContentClassificationModal(true)} title="Add Content Classification">
                                    <MdAddCircle style={{ width: "20px", height: "20px" }} />
                                </button>
                            </div>
                            <div className="mb-3">
                                <Select id="episode-content-classification" options={defaultOption?.contentClassificationOption} isMulti name={'selected_content_classification'} onChange={handleMultiSelect} value={formData?.selected_content_classification} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                            </div>
                            <div className="d-flex justify-content-between align-items-start">
                                <div className="pe-2">
                                    <MessageLabel text={labelDisplay?.[14]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[14]?.sub_title} />
                                </div>
                                <button type="button" id="episode-language-add-button" className="vjs-big-play-button rounded" onClick={() => setLanguageModal(true)} title="Add Language">
                                    < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                </button>
                            </div>
                            <Select id="episode-language" options={defaultOption?.languageOption} isMulti name={'selected_Languages'} onChange={handleMultiSelect} value={formData?.selected_Languages} className="custom-select-multi custom-placeholder theme-text-color mb-3" />

                            <MessageLabel text={labelDisplay?.[10]?.title} />
                            <MessageSubHeading text={labelDisplay?.[10]?.sub_title} />
                            <AdminCustomSelect id="episode-rating" name="rating" value={formData?.rating} onChange={handleInput} ref={(el) => (combinedRef.current.rating = el)} options={Array.from({ length: 10 })?.map((item, index) => ({ name: index + 1, value: index + 1 }))} error={formDataError?.rating} defaultOptionName={"Choose an rating"} />

                            <div className="d-flex justify-content-between align-items-start">
                                <div className="pe-2">
                                    <MessageLabel text={labelDisplay?.[12]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[12]?.sub_title} />
                                </div>
                                <button type="button" id="episode-artist-add-button" className="vjs-big-play-button rounded" onClick={() => setArtistModal(true)} title="Add Artist">
                                    < MdAddCircle style={{ width: "20px", height: "20px" }} />
                                </button>
                            </div>
                            <Select id="episode-artists" options={defaultOption?.artistsOption} isMulti name={'selected_artists'} onChange={handleMultiSelect} value={formData?.selected_artists} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                        </Wrapper>

                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[7]?.title} />
                            <MessageLabel text={labelDisplay?.[7]?.title} className="mandatorySimple" />
                            <MessageSubHeading text={labelDisplay?.[7]?.sub_title} />
                            <AdminCustomInput id="episode-duration" type="text" maxLength="6" name="duration" value={formData?.duration} ref={(el) => (combinedRef.current.duration = el)} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.duration} />

                            {currentType !== "embed_code" && (
                                <>
                                    <div className="d-flex justify-content-between mb-2 mt-3">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={labelDisplay?.[20]?.title} className={formData?.free_duration_status == 1 ? "mandatorySimple" : ""} />
                                        </div>
                                        <div className="col-6 col-md-6 ps-2 text-end">
                                            <AdminSwitch id="episode-free-duration-status" name={'free_duration_status'} checked={formData?.free_duration_status} onChange={handleInput} />
                                        </div>
                                    </div>

                                    {formData?.free_duration_status == 1 && <>
                                        <MessageLabel text={labelDisplay?.[21]?.title} />
                                        <MessageSubHeading text={labelDisplay?.[21]?.sub_title} />
                                        <AdminCustomInput id={"episode-free-duration-time"} ref={(el) => (combinedRef.current.free_duration_time = el)} type="text" maxLength="6" name="free_duration_time" value={formData?.free_duration_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.free_duration_time} />
                                    </>}
                                </>
                            )}
                        </Wrapper>

                        {(getGeofencing === "ON" || getGeofencingAvailableCountries === 1) && (
                            <Wrapper>
                                <MessageHeading text={labelDisplay?.[50]?.title} />
                                {getGeofencing === "ON" && (
                                    <>
                                        <MessageLabel text={labelDisplay?.[15]?.title} />
                                        <MessageSubHeading text={labelDisplay?.[15]?.sub_title} />
                                        <Select
                                            id="episode-block-country"
                                            options={defaultOption?.blockCountryOption?.filter(
                                                (blockedItem) =>
                                                    !formData?.selected_available_country?.some(
                                                        (availableItem) => availableItem?.value === blockedItem?.value
                                                    )
                                            )}
                                            isMulti
                                            name="selected_blocked_country"
                                            onChange={handleMultiSelect}
                                            value={formData?.selected_blocked_country}
                                            className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                        />
                                    </>
                                )}

                                {getGeofencingAvailableCountries === 1 && (
                                    <>
                                        <MessageLabel text={labelDisplay?.[16]?.title} />
                                        <MessageSubHeading text={labelDisplay?.[16]?.sub_title} />
                                        <Select
                                            id="episode-available-country"
                                            options={defaultOption?.availableCountryOption?.filter(
                                                (AvailableItem) =>
                                                    !formData?.selected_blocked_country?.some(
                                                        (blockedItem) => blockedItem?.value === AvailableItem?.value
                                                    )
                                            )}
                                            isMulti
                                            name="selected_available_country"
                                            onChange={handleMultiSelect}
                                            value={formData?.selected_available_country}
                                            className="custom-select-multi custom-placeholder theme-text-color mb-3"
                                        />
                                    </>
                                )}
                            </Wrapper>
                        )}

                        <Wrapper>
                            <h5 className={` theme-text-color  theme-border-secondary-color pb-3 mb-3 mt-0 `}>{labelDisplay?.[30]?.title} <small> {labelDisplay?.[30]?.sub_title} </small></h5>
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={labelDisplay?.[31]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[31]?.sub_title} />
                                    <AdminCustomInput id="episode-skip-start-time" type="text" name="skip_start_time" value={formData?.skip_start_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.skip_start_time} maxLength={"6"} ref={(el) => (combinedRef.current.skip_start_time = el)} />
                                </div>
                                <div className="col-6 col-md-6 ps-2">
                                    <MessageLabel text={labelDisplay?.[32]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[32]?.sub_title} />
                                    <AdminCustomInput id="episode-skip-end-time" type="text" name="skip_end_time" value={formData?.skip_end_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.skip_end_time} maxLength={"6"} ref={(el) => (combinedRef.current.skip_end_time = el)} />
                                </div>
                            </div>

                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={labelDisplay?.[33]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[33]?.sub_title} />
                                    <AdminCustomInput id="episode-recap-start-time" type="text" name="recap_start_time" value={formData?.recap_start_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.recap_start_time} maxLength={"6"} ref={(el) => (combinedRef.current.recap_start_time = el)} />
                                </div>
                                <div className="col-6 col-md-6 ps-2">
                                    <MessageLabel text={labelDisplay?.[34]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[34]?.sub_title} />
                                    <AdminCustomInput id="episode-recap-end-time" type="text" name="recap_end_time" value={formData?.recap_end_time} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.recap_end_time} maxLength={"6"} ref={(el) => (combinedRef.current.recap_end_time = el)} />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={labelDisplay?.[35]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[35]?.sub_title} />
                                    <AdminCustomInput id="episode-skip-start-session" type="text" name="skip_start_session" value={formData?.skip_start_session} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.skip_start_session} maxLength={"6"} ref={(el) => (combinedRef.current.skip_start_session = el)} />
                                </div>
                                <div className="col-6 col-md-6 ps-2">
                                    <MessageLabel text={labelDisplay?.[36]?.title} />
                                    <MessageSubHeading text={labelDisplay?.[36]?.sub_title} />
                                    <AdminCustomInput id="episode-recap-start-session" type="text" name="recap_start_session" value={formData?.recap_start_session} onChange={handleInput} placeHolder={"HH:MM:SS"} error={formDataError?.recap_start_session} maxLength={"6"} ref={(el) => (combinedRef.current.recap_start_session = el)} />
                                </div>
                            </div>
                        </Wrapper>


                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[22]?.title} />
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={labelDisplay?.[23]?.title} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch id="episode-featured" name={'featured'} checked={formData?.featured === 1} onChange={handleInput} />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={labelDisplay?.[24]?.title} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch id="episode-active" name={'active'} checked={formData?.active === 1} onChange={handleInput} />
                                </div>
                            </div>
                        </Wrapper>
                        <Wrapper>
                            <MessageHeading text={"Slider Setting"} />
                            <div className="d-flex justify-content-between mb-2 ">
                                <div className="col-6 col-md-6 pe-2">
                                    <MessageLabel text={"Enable as Slider"} />
                                </div>
                                <div className="col-6 col-md-6 ps-2 text-end">
                                    <AdminSwitch id="episode-banner" name={'banner'} checked={formData?.banner === 1} onChange={handleInput} />
                                </div>
                            </div>
                            {formData?.banner === 1 && (
                                <>
                                    <MessageLabel text="Slider Image" className={`${formData?.banner === 1 ? 'mandatorySimple' : ''}`} />
                                    <MessageSubHeading text="Resolution 3840*1440 and Ratio 8:3" />
                                    <AdminImageUploadZone
                                        idAttribute={`episode-slider-image-${episodeId}`}
                                        onChange={handleFileChange}
                                        selectedFile={sliderImageFile}
                                        uploadedImage={formData?.Slider_Thumbnail}
                                        onDelete={handleClearSelectFile}
                                        ref={(el) => (combinedRef.current.slider_image = el)}
                                        name="slider_image"
                                        apiFieldName="slider_image"
                                        error={formDataError?.slider_image}
                                        id={episodeId}
                                    />
                                </>
                            )}
                            {(onlyPermission?.includes(48)) && (
                                <div className="d-flex justify-content-between mb-2 ">
                                    <div className="col-6 col-md-6 pe-2">
                                        <MessageLabel text={"Promote as Advertisement"} />
                                    </div>
                                    <div className="col-6 col-md-6 ps-2 text-end">
                                        <AdminSwitch id="episode-is-ads" name={'is_ads'} checked={formData?.is_ads === 1} onChange={handleInput} />
                                    </div>
                                </div>
                            )}
                        </Wrapper>
                        <Wrapper>
                            <MessageHeading text="Advertisement" />
                            <div className="mb-2 col-12">
                                {/* First Row: Pre & Post Ads */}
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <MessageLabel text="Choose the Pre Position Advertisement" />
                                        <select
                                            id="episode-pre-ads-select"
                                            value={formData?.pre_ads}
                                            name="pre_ads"
                                            onChange={handleInput}
                                            className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                                        >
                                            <option value="0">Choose Pre Ads</option>
                                            {preadsarray?.map((item, key) => (
                                                <option key={key} value={item?.id}>{item?.ads_name} {item?.ad_unique_id ? ` (${item.ad_unique_id})` : ""}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <MessageLabel text="Choose the Post Position Advertisement" />
                                        <select
                                            id="episode-post-ads-select"
                                            value={formData?.post_ads}
                                            name="post_ads"
                                            onChange={handleInput}
                                            className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                                        >
                                            <option value="0">Choose Post Ads</option>
                                            {postadsarray?.map((item, key) => (
                                                <option key={key} value={item?.id}>{item?.ads_name} {item?.ad_unique_id ? ` (${item.ad_unique_id})` : ""}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Second Row: Mid Ads Category & Sequence */}
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <MessageLabel text="Choose the Mid Category Advertisement" />
                                        <select
                                            id="episode-category-select"
                                            value={formData?.mid_ads_category}
                                            name="mid_ads_category"
                                            onChange={handleInput}
                                            className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                                        >
                                            <option value="0">Choose Mid Ads</option>
                                            <option value={"random"}>Random</option>
                                            {midadsarray?.map((item, key) => (
                                                <option key={key} value={item?.id}>{item?.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <MessageLabel text="Mid Advertisement Sequence Time" />
                                        {/* <MessageSubHeading text={`Ex: 00:20:00 every 20 minutes ${midadsarray?.filter((item) => item?.id == formData?.mid_ads_category).flatMap(item => item?.name)} ads play`} /> */}
                                        <AdminCustomInput
                                            id="episode-category-sequence"
                                            type="text"
                                            ref={(el) => (combinedRef.current.mid_advertisement_sequence_time = el)}
                                            name="mid_advertisement_sequence_time"
                                            value={formData?.mid_advertisement_sequence_time}
                                            onChange={handleInput}
                                            placeHolder={"HH:MM:SS"}
                                            error={formDataError?.mid_advertisement_sequence_time}
                                            maxLength={"6"}
                                        />
                                    </div>
                                    <div className="col-12 col-md-12 mb-3">
                                        <MessageLabel text="Custom SSAI VMAP URL" />
                                        <AdminCustomInput
                                            type="text"
                                            name="ssai_vmap_url"
                                            value={formData?.ssai_vmap_url}
                                            onChange={handleInput}
                                            placeHolder={"https://example.com/vmap.xml"}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Wrapper>

                    </LeftWrapper>
                    <RightWrapper>
                        <Wrapper style={{ height: '85vh' }}>
                            <MessageLabel text={`Active Video Type : ${formData?.type?.replace(/_/g, " ") == "transcoding video" || formData?.type?.replace(/_/g, " ") == "m3u8 url" ? "HLS" : formData?.type?.replace(/_/g, " ")}`} className={"mb-sm-3"} />
                            {(formData?.episode_url || formData?.mp4_url || formData?.m3u8_url) && formData?.episode_format !== "embed_url" && !(formData?.type == "transcoding_video" && !formData?.m3u8_url) &&
                                <AdminCustomURLCopy link={formData?.episode_url || formData?.mp4_url || formData?.m3u8_url} fieldName={""} className="copy-board-input" />
                            }
                            <div className="adminVideoPlayer playerHeight vjs-16-9">
                                {
                                    formData?.episode_format == "embed_url" ? <AdminYoutubePlayer src={formData?.episode_url} /> :
                                        (formData?.type == "transcoding_video" && !formData?.m3u8_url)
                                            ? <AdminProcessButton cell={formData.draft == 0 ? "PROCESS" : formData.active == 1 && formData.status == 1 ? "PUBLISHED" : "UNPUBLISHED"} row={{ ...formData }} />
                                            : <AdminMiniPlayer url={formData?.episode_url || formData?.mp4_url || formData?.m3u8_url} videoFormat={formData?.episode_format} title={formData?.title} poster={formData?.player_image_url} className="playerHeight" />
                                }
                            </div>

                            {formData?.type === 'brightcove' && (
                                <div className="mt-2 mb-1">
                                    <MessageLabel text={`Brightcove Video ID : ${formData?.brightcove_video_id}`} />
                                </div>
                            )}

                        </Wrapper>
                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[26]?.title} />
                            <MessageLabel text={labelDisplay?.[27]?.title} className={`${imagerequiredValidation?.episode === 1 ? 'mandatorySimple' : ""}`} />
                            <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[27]?.sub_title, 'portrait')} />
                            <AdminImageUploadZone
                                idAttribute="episode-thumbnail-image"
                                onChange={handleFileChange}
                                selectedFile={coverImageFile}
                                uploadedImage={formData?.image_url}
                                onDelete={handleClearSelectFile}
                                ref={(el) => (combinedRef.current.image = el)}
                                name="image"
                                orientationSlug="portrait"
                                id={episodeId}
                                error={formDataError?.image}
                            />
                            <MessageLabel text={labelDisplay?.[28]?.title} className={`${imagerequiredValidation?.episode === 1 ? 'mandatorySimple' : ""}`} />
                            <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[28]?.sub_title, 'landscape')} />
                            <AdminImageUploadZone
                                idAttribute="episode-player-image"
                                onChange={handleFileChange}
                                selectedFile={playerImageFile}
                                uploadedImage={formData?.player_image_url}
                                onDelete={handleClearSelectFile}
                                ref={(el) => (combinedRef.current.player_image = el)}
                                name="player_image"
                                orientationSlug="landscape"
                                id={episodeId}
                                error={formDataError?.player_image}
                            />
                            <MessageLabel text={labelDisplay?.[29]?.title} className={`${imagerequiredValidation?.episode === 1 ? 'mandatorySimple' : ""}`} />
                            <MessageSubHeading text={buildDynamicSubText(labelDisplay?.[29]?.sub_title, 'landscape')} />
                            <AdminImageUploadZone
                                idAttribute="episode-tv-image"
                                onChange={handleFileChange}
                                selectedFile={tvImageFile}
                                uploadedImage={formData?.tv_image_url}
                                onDelete={handleClearSelectFile}
                                ref={(el) => (combinedRef.current.tv_image = el)}
                                name="tv_image"
                                orientationSlug="landscape"
                                error={formDataError?.tv_image}
                                id={episodeId}
                            />
                        </Wrapper>

                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[51]?.title} />
                            <MessageLabel text={labelDisplay?.[51]?.sub_title} className="" />
                            <AdminCustomSelect id="episode-trailer-type" name="trailer_type" value={formData?.trailer_type === "transcoding_video" ? "mp4_video_upload" : formData?.trailer_type}
                                onChange={handleInput} error={formDataError?.trailer_type} ref={(el) => (combinedRef.current.trailer_type = el)} options={defaultOption?.trailerOption?.map((item) => ({ name: item?.name, value: item?.trailer_type, id: `episode${item?.trailer_type}` }))} />{formData?.trailer_type === "mp4_video_upload" && (
                                    <>
                                        <input
                                            type="file"
                                            id="episode-trailer"
                                            className="form-control"
                                            name="trailer_url"
                                            accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo"
                                            onChange={(e) => handleLibraryChange(e, "trailer")}
                                        />
                                        {formDataError?.trailer_url && (
                                            <p className="errorred  d-block mt-2"><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /> {formDataError.trailer_url}</p>
                                        )}
                                    </>
                                )}

                            {formData?.trailer_type == "m3u8_url" ? <AdminCustomInput type="text" id="episode-trailer-m3u8_url" name="trailer_url" value={formData?.trailer_url} ref={(el) => (combinedRef.current.trailer_url = el)} onChange={handleInput} placeHolder={"Please enter trailer m3u8 url"} error={formDataError?.trailer_url} /> : ""}
                            {formData?.trailer_type == "mp4_url" ? <AdminCustomInput type="text" id="episode-trailer-mp4-url" name="trailer_url" value={formData?.trailer_url} ref={(el) => (combinedRef.current.trailer_url = el)} onChange={handleInput} placeHolder={"Please enter trailer mp4 url"} error={formDataError?.trailer_url} /> : ""}
                            {formData?.trailer_type == "embed_url" ? <AdminCustomInput type="text" id="episode-trailer-embed-url" name="trailer_url" value={formData?.trailer_url} ref={(el) => (combinedRef.current.trailer_url = el)} onChange={handleInput} placeHolder={"Please enter trailer embed code"} error={formDataError?.trailer_url} /> : ""}
                            {formData?.trailer_type == "brightcove" ? <AdminCustomInput type="text" id="episode-trailer-brightcove" name="brightcove_trailer_id" value={formData?.brightcove_trailer_id} ref={(el) => (combinedRef.current.brightcove_trailer_id = el)} onChange={handleInput} placeHolder={"Please enter trailer Brightcove ID"} error={formDataError?.brightcove_trailer_id} /> : ""}
                            {formData?.trailer_source_url ?
                                <>

                                    <MessageLabel text={`Active Trailer Type : ${formData?.trailer_type?.replace(/_/g, " ") == "transcoding video" || formData?.trailer_type?.replace(/_/g, " ") == "m3u8 url" ? "HLS" : formData?.trailer_type?.replace(/_/g, " ")}`} className={"mb-sm-3 mt-3"} />

                                    <div className="adminVideoPlayer playerHeight vjs-16-9">
                                        {formData?.trailer_format == "embed_url" ? <AdminYoutubePlayer src={formData?.trailer_source_url} /> :
                                            (formData?.trailer_type == "transcoding_video" && !formData?.trailer_source_url)
                                                ? <AdminProcessButton cell={formData.draft == 0 ? "PROCESS" : formData.active == 1 && formData.status == 1 ? "PUBLISHED" : "UNPUBLISHED"} row={{ ...formData }} />
                                                : <AdminMiniPlayer url={formData?.trailer_source_url || formData?.mp4_url || formData?.m3u8_url} videoFormat={formData?.trailer_format} title={formData?.title ? `${formData.title} - Trailer` : ''} poster={formData?.player_image_url} className="playerHeight" />}
                                    </div>
                                    {(formData?.trailer_source_url || formData?.mp4_url || formData?.m3u8_url) && formData?.trailer_format !== "embed_url" && !(formData?.trailer_type == "transcoding_video" && !formData?.trailer_source_url) &&
                                        <AdminCustomURLCopy link={formData?.trailer_source_url || formData?.mp4_url || formData?.m3u8_url} fieldName={""} className="copy-board-input mt-3" />
                                    }
                                </> : ""}
                            <AdminCustomButton id="epsiodeLibraryTrailer" saveMethod={() => handleToggleGalleryModel()} saveText="Choose from library" className="mt-2" />
                        </Wrapper>



                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[37]?.title} />
                            <MessageLabel text={labelDisplay?.[38]?.title} className="mandatorySimple" />
                            <MessageSubHeading text={labelDisplay?.[38]?.sub_title} />
                            {/* <AdminCustomSelect id="episode-access" name="access" value={formData?.access} onChange={handleInput} ref={(el) => (combinedRef.current.access = el)} options={filteredAccessOptions?.map((item) => ({ name: item?.name, value: item?.role }))} error={formDataError?.access} defaultOptionName={"Choose an user access"} /> */}
                            <AdminCustomSelect
                                id="season-access"
                                name="access"
                                value={formData?.access}
                                onChange={handleInput}
                                ref={(el) => (combinedRef.current.access = el)}
                                options={filteredAccessOptions?.map((item) => ({
                                    name: item?.name,
                                    value: item?.role,
                                }))}
                                error={formDataError?.access}
                                defaultOptionName="Select access level"
                            />

                            {formData?.access === "ppv" && seasonmatchuserdata?.Series?.access !== "ppv" && <>
                                {globalPpvStatusActive?.PPV_Individual_Contents == 0 ?
                                    (
                                        <div className="mt-3">
                                            <MessageLabel text={labelDisplay?.[47]?.title} />
                                            <AdminCustomInput id="episode-global-ppv-input" type="number" name="ppv_price" value={formData?.ppv_price} onChange={handleInput} placeHolder={"Please eneter ppv price"} ref={(el) => (combinedRef.current.ppv_price = el)} error={formDataError?.ppv_price} />
                                            <MessageLabel text={labelDisplay?.[48]?.title} />
                                            <AdminCustomSelect id="episode-ios-ppv-price" name="ios_ppv_price" value={formData?.ios_ppv_price || 0} onChange={handleInput} ref={(el) => (combinedRef.current.ios_ppv_price = el)} options={defaultOption?.iosOption?.map((item) => ({ name: item?.plan_price, value: item?.id }))} error={formDataError?.ios_ppv_price} defaultOptionName={"Choose an ios price"} />
                                        </div>
                                    )
                                    :
                                    <div className="mt-3">
                                        <AdminCustomButton id="episode-custom-ppv-button" saveMethod={() => handlePriceModal()} saveText="Customize PPV" className="d-block ms-auto mt-3" />
                                    </div >
                                }
                                {/* {Array.isArray(defaultOption?.googleProductIdPPV) && defaultOption.googleProductIdPPV.length > 0 && (
                                    <div className="mt-3">
                                        <MessageLabel text="Google Product" />
                                        <AdminCustomSelect
                                            id="main-episode-google-product-ppvs"
                                            name="google_product_id_ppvs_id"
                                            value={formData?.google_product_id_ppvs_id || ''}
                                            onChange={(e) => {
                                                const planId = e.target.value;
                                                setFormData(prev => ({
                                                    ...prev,
                                                    google_product_id_ppvs_id: planId ? parseInt(planId) : null,
                                                }));
                                            }}
                                            options={defaultOption.googleProductIdPPV.map(plan => ({
                                                name: plan?.product_id || plan?.name || `Product ${plan?.id}`,
                                                value: plan?.id,
                                            }))}
                                            defaultOptionName="Choose Google Purchase"
                                        />
                                    </div>
                                )} */}
                            </>}
                        </Wrapper>

                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[39]?.title} />

                            <MessageLabel text={labelDisplay?.[40]?.title} />
                            <MessageSubHeading text={labelDisplay?.[40]?.sub_title} />
                            <AdminCustomInput id="episode-website-page-title" name="website_page_title" value={formData?.website_page_title} ref={(el) => (combinedRef.current.website_page_title = el)} onChange={handleInput} placeHolder={"Website title"} error={formDataError?.website_page_title} />

                            <MessageLabel text={labelDisplay?.[41]?.title} />
                            <MessageSubHeading text={labelDisplay?.[41]?.sub_title} />
                            <AdminCustomInput id="episode-website-url" name="website_URL" value={formData?.website_URL} onChange={handleInput} placeHolder={"Website url"} ref={(el) => (combinedRef.current.website_URL = el)} error={formDataError?.website_URL} />

                            <MessageLabel text={labelDisplay?.[42]?.title} />
                            <MessageSubHeading text={labelDisplay?.[42]?.sub_title} />
                            <AdminCustomArea id="episode-meta-description" name="Meta_description" value={formData?.Meta_description || ""} onChange={handleInput} ref={(el) => (combinedRef.current.Meta_description = el)} placeHolder={"Please enter Meta description"} rows={5} />
                        </Wrapper>


                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[17]?.title} />
                            <MessageLabel text={labelDisplay?.[18]?.title} className="" />
                            <MessageSubHeading text={labelDisplay?.[18]?.sub_title} />
                            <TagsInput id="episode-search-tags" name="search_tags" value={formData?.search_tags} separators={["Enter", ","]} classNames={{ tag: "episode-search-tags custom-search-tag", input: "w-100" }} onChange={handleTagsChange} />
                        </Wrapper>

                        <Wrapper>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <MessageHeading text={labelDisplay?.[43]?.title} noMargin />
                                <div className="d-flex gap-2 pb-3">
                                    <AdminDownloadFile name="Sample SRT" value={true} link="/sample_subtitles/sample.srt" paddingClass="px-2 py-1" gapClass="gap-2" className="fs-7" />
                                    <AdminDownloadFile name="Sample VTT" value={true} link="/sample_subtitles/sample.vtt" paddingClass="px-2 py-1" gapClass="gap-2" className="fs-7" />
                                </div>
                            </div>

                            {defaultOption?.videoSubtitle?.map((item, index) => (
                                <div key={index} >
                                    <div className="d-flex justify-content-between mb-2 ">
                                        <div className="col-6 col-md-6 pe-2">
                                            <MessageLabel text={item?.language} />
                                        </div>
                                        {item?.subtitle_url && <div className="col-6 col-md-6 ps-2 text-end mb-3 d-flex align-items-center justify-content-end gap-3">
                                            {/* <AdminDownloadFile id="episode-subtitle-url" name={'Download'} value={item?.subtitle_url} link={item?.subtitle_url} /> */}
                                            <div onClick={() => handleSubtitleDelete(item)}>
                                                <IconMyDelete styled={{ width: "20px", height: "20px" }} />
                                            </div>
                                        </div>}
                                    </div>
                                    <AdminImageUploadZone
                                        idAttribute='videoSubtitle'
                                        onChange={handleFileChange}
                                        selectedFile={subtitleFile?.[item.short_code]}
                                        uploadedImage={item?.subtitle_url}
                                        onDelete={handleClearSelectFile}
                                        fileInputRef={focusInput}
                                        name={item?.short_code}
                                        id={episodeId}
                                        previewFalse={true}
                                        accept="text/vtt,text/srt,.vtt,.srt"
                                        error={formDataError?.[item?.short_code]}
                                        icon={<PiSubtitlesLight />}
                                    />
                                </div>
                            ))}
                        </Wrapper>

                        {onlyPermission?.includes(44) &&
                            <PushNotificationSettings
                                formData={formData}
                                setFormData={setFormData}
                                handleInput={handleInput}
                                handleFileChange={handleFileChange}
                                selectedFile={notificationImageFile}
                                uploadedImage={formData?.push_notification_image_url}
                                onDelete={handleClearSelectFile}
                                combinedRef={combinedRef}
                                formDataError={formDataError}
                                siteTheme={siteTheme}
                                id={episodeId}
                                onlyPermission={onlyPermission}
                                sourceTitle={formData?.title}
                                sourceDescription={formData?.episode_description}
                                sourceType={4}
                                sourceTypeName="Episodes"
                                slug={formData?.slug}
                                prefix="episode"
                            />
                        }

                    </RightWrapper>
                    <AdminCustomButton id="episodeFormSubmitButtonDown" className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={labelDisplay?.[44]?.title} loading={showOverlay} />
                </FormContainer>
            </React.Fragment>
        </div>
    )
}
const mapStateToProps = (state) => ({
    storageSetting: state.storageSetting.data,
    siteTheme: state.siteTheme.siteTheme,
    languageCodeData: state.languageCode.languageCodeData,
    onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(EpisodeAddUpate)
